import SearchResults from './SearchResults.jsx';

export default SearchResults;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/SearchResults/index.js